import React from 'react';

import { Subspace, TabbedSpace } from '~src/spacesPlatform/components/spaceComponents/TabbedSpace';

import { Messages } from '../../../../codegen/Localize';
import { IGetUserSettingsResult } from '../../../../ts/ServerApi/requests/GetUserSettingsRequest';
import { UserSettingsSubspace } from '../../../../userSettings/components/UserSettingsSubspace';
import { SiteRoleOptionsResource } from '../../../services/resources/SiteRoleOptions';
import { IServerUserInfo } from '../../models/IServerUserInfo';
import { UserSpaceHeader } from '../siteUserSpace/SiteUserSpaceHeader';

export interface ServerUserSpaceProps {
  readonly user: IServerUserInfo;
  readonly userSettings: IGetUserSettingsResult;
  readonly userRefreshTokenCount: number;
  readonly isSessionUserSelf: boolean;
  readonly siteRoleOptions: SiteRoleOptionsResource;
}

export class ServerUserSpace extends React.PureComponent<ServerUserSpaceProps> {
  public render(): JSX.Element {
    const subspaces = getServerUserSubspaces(this.props);
    return (
      <TabbedSpace
        subspaces={subspaces}
        activeSubspaceName={'settings'}
        urlForSubspace={this.urlForSubspace}
        mastheadElement={this.mastheadElement()}
        testIdPrefix={'serveruser'}
        spaceItemName={this.props.user.displayName}
      />
    );
  }

  private urlForSubspace = () => '';

  private mastheadElement = (): React.ReactNode => {
    return (
      <UserSpaceHeader
        item={this.props.user}
        inServerArea={true}
        siteRole={this.props.user.maxSiteRole}
        siteRoleOptions={this.props.siteRoleOptions}
        userSettings={this.props.userSettings}
        isSessionUserSelf={this.props.isSessionUserSelf}
        isSessionServerAdmin={true}
        isSessionSiteAdmin={false}
        isServerDomainFamilyActiveDirectory={false}
      />
    );
  }
}

function getServerUserSubspaces(serverUserSpaceProps: ServerUserSpaceProps): ReadonlyArray<Subspace> {
  return [
    {
      name: 'settings',
      tabLabel: Messages.settings(),
      shouldRenderTabContentCount: false,
      renderContent: () =>
      <UserSettingsSubspace
        userSettings={serverUserSpaceProps.userSettings}
        userRefreshTokenCount={serverUserSpaceProps.userRefreshTokenCount}
        isSessionUserSelf={serverUserSpaceProps.isSessionUserSelf}
        serverUser={serverUserSpaceProps.user}
        isServerUserSubplace={true}/>
    }
  ];
}
